import React from 'react'
import Box from '@/components/UI/box/Box'
import Skeleton from '@/components/UI/skeleton/Skeleton'
import styles from './HomeSearchSkeleton.module.scss'
const HomeSearchSkeleton: React.FC = () => {
  return (
    <>
      {[1, 2, 3, 4, 5, 6].map(item => {
        return (
          <Box key={`SKELETON_ITEM_${item}`} className={styles['container']}>
            <Box className={styles['icon']}>
              <Skeleton variant="rounded" width={40} height={40} />
            </Box>
            <Box className={styles['text']}>
              <Skeleton height={11} width="100%" />
              <Skeleton height={9} width="60%" />
            </Box>
          </Box>
        )
      })}
    </>
  )
}

export default HomeSearchSkeleton
